import { emptyEmailServiceApi as api } from './baseEmailApi';
export const addTagTypes = [
  'email-accounts',
  'warmup:warmup-pool',
  'warmup:warmup-profile',
  'email-accounts:auth',
  'warmup:user-status',
  'campaigns',
  'campaigns:sequence',
  'campaigns:analytics',
  'image',
  'webhooks',
  'leads',
  'statistics',
  'master-inbox',
  'custom-domains',
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: build => ({
      emailAccountControllerGetAllEmailAccounts: build.query<
        EmailAccountControllerGetAllEmailAccountsApiResponse,
        EmailAccountControllerGetAllEmailAccountsApiArg
      >({
        query: queryArg => ({
          url: `/email-accounts`,
          params: { username: queryArg.username, offset: queryArg.offset, limit: queryArg.limit },
        }),
        providesTags: ['email-accounts'],
      }),
      emailAccountControllerGetEmailAccount: build.query<
        EmailAccountControllerGetEmailAccountApiResponse,
        EmailAccountControllerGetEmailAccountApiArg
      >({
        query: queryArg => ({ url: `/email-accounts/${queryArg.id}` }),
        providesTags: ['email-accounts'],
      }),
      emailAccountControllerUpdateEmailAccount: build.mutation<
        EmailAccountControllerUpdateEmailAccountApiResponse,
        EmailAccountControllerUpdateEmailAccountApiArg
      >({
        query: queryArg => ({
          url: `/email-accounts/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.updateEmailAccountDto,
        }),
        invalidatesTags: ['email-accounts'],
      }),
      emailAccountControllerDeleteEmailAccount: build.mutation<
        EmailAccountControllerDeleteEmailAccountApiResponse,
        EmailAccountControllerDeleteEmailAccountApiArg
      >({
        query: queryArg => ({ url: `/email-accounts/${queryArg.id}`, method: 'DELETE' }),
        invalidatesTags: ['email-accounts'],
      }),
      emailAccountControllerTestConnection: build.mutation<
        EmailAccountControllerTestConnectionApiResponse,
        EmailAccountControllerTestConnectionApiArg
      >({
        query: queryArg => ({ url: `/email-accounts/${queryArg.id}/test`, method: 'POST' }),
        invalidatesTags: ['email-accounts'],
      }),
      emailAccountControllerGetWarmupStatus: build.query<
        EmailAccountControllerGetWarmupStatusApiResponse,
        EmailAccountControllerGetWarmupStatusApiArg
      >({
        query: queryArg => ({ url: `/email-accounts/${queryArg.id}/warmup-status` }),
        providesTags: ['email-accounts'],
      }),
      emailAccountControllerStartWarmup: build.mutation<
        EmailAccountControllerStartWarmupApiResponse,
        EmailAccountControllerStartWarmupApiArg
      >({
        query: queryArg => ({ url: `/email-accounts/${queryArg.id}/start-warmup`, method: 'POST' }),
        invalidatesTags: ['email-accounts'],
      }),
      emailAccountControllerPauseWarmup: build.mutation<
        EmailAccountControllerPauseWarmupApiResponse,
        EmailAccountControllerPauseWarmupApiArg
      >({
        query: queryArg => ({ url: `/email-accounts/${queryArg.id}/pause-warmup`, method: 'POST' }),
        invalidatesTags: ['email-accounts'],
      }),
      warmupPoolControllerCreateWarmupPool: build.mutation<
        WarmupPoolControllerCreateWarmupPoolApiResponse,
        WarmupPoolControllerCreateWarmupPoolApiArg
      >({
        query: () => ({ url: `/warmup/warmup-pool`, method: 'POST' }),
        invalidatesTags: ['warmup:warmup-pool'],
      }),
      warmupPoolControllerAddToWarmupPool: build.mutation<
        WarmupPoolControllerAddToWarmupPoolApiResponse,
        WarmupPoolControllerAddToWarmupPoolApiArg
      >({
        query: queryArg => ({
          url: `/warmup/warmup-pool/${queryArg.id}/email-account`,
          method: 'POST',
          body: queryArg.emailAccountWarmupPoolDto,
        }),
        invalidatesTags: ['warmup:warmup-pool'],
      }),
      warmupPoolControllerRemoveFromWarmupPool: build.mutation<
        WarmupPoolControllerRemoveFromWarmupPoolApiResponse,
        WarmupPoolControllerRemoveFromWarmupPoolApiArg
      >({
        query: queryArg => ({
          url: `/warmup/warmup-pool/${queryArg.id}/email-account`,
          method: 'DELETE',
          body: queryArg.emailAccountWarmupPoolDto,
        }),
        invalidatesTags: ['warmup:warmup-pool'],
      }),
      warmupPoolControllerGetWarmupPool: build.query<
        WarmupPoolControllerGetWarmupPoolApiResponse,
        WarmupPoolControllerGetWarmupPoolApiArg
      >({
        query: queryArg => ({ url: `/warmup/warmup-pool/${queryArg.id}` }),
        providesTags: ['warmup:warmup-pool'],
      }),
      warmupProfileControllerGetActiveWarmupProfiles: build.query<
        WarmupProfileControllerGetActiveWarmupProfilesApiResponse,
        WarmupProfileControllerGetActiveWarmupProfilesApiArg
      >({
        query: () => ({ url: `/warmup/profiles/active` }),
        providesTags: ['warmup:warmup-profile'],
      }),
      warmupProfileControllerGetAllWarmupProfiles: build.query<
        WarmupProfileControllerGetAllWarmupProfilesApiResponse,
        WarmupProfileControllerGetAllWarmupProfilesApiArg
      >({
        query: () => ({ url: `/warmup/warmup-profile` }),
        providesTags: ['warmup:warmup-profile'],
      }),
      warmupProfileControllerUpsertWarmupProfile: build.mutation<
        WarmupProfileControllerUpsertWarmupProfileApiResponse,
        WarmupProfileControllerUpsertWarmupProfileApiArg
      >({
        query: queryArg => ({ url: `/warmup/warmup-profile`, method: 'POST', body: queryArg.addWarmupDto }),
        invalidatesTags: ['warmup:warmup-profile'],
      }),
      warmupProfileControllerGetWarmupStats: build.query<
        WarmupProfileControllerGetWarmupStatsApiResponse,
        WarmupProfileControllerGetWarmupStatsApiArg
      >({
        query: queryArg => ({
          url: `/warmup/warmup-profile/${queryArg.id}/warmup-stats`,
          params: { startDate: queryArg.startDate, endDate: queryArg.endDate },
        }),
        providesTags: ['warmup:warmup-profile'],
      }),
      warmupProfileControllerExecuteInboxVerification: build.mutation<
        WarmupProfileControllerExecuteInboxVerificationApiResponse,
        WarmupProfileControllerExecuteInboxVerificationApiArg
      >({
        query: queryArg => ({
          url: `/warmup/warmup-profile/${queryArg.id}/execute-inbox-verification`,
          method: 'POST',
        }),
        invalidatesTags: ['warmup:warmup-profile'],
      }),
      warmupProfileControllerExecuteWarmup: build.mutation<
        WarmupProfileControllerExecuteWarmupApiResponse,
        WarmupProfileControllerExecuteWarmupApiArg
      >({
        query: queryArg => ({ url: `/warmup/execute`, method: 'POST', body: queryArg.executeWarmupDto }),
        invalidatesTags: ['warmup:warmup-profile'],
      }),
      emailAuthControllerGoogleAuth: build.query<
        EmailAuthControllerGoogleAuthApiResponse,
        EmailAuthControllerGoogleAuthApiArg
      >({
        query: () => ({ url: `/email-accounts/auth/google` }),
        providesTags: ['email-accounts:auth'],
      }),
      emailAuthControllerGoogleAuthCallback: build.query<
        EmailAuthControllerGoogleAuthCallbackApiResponse,
        EmailAuthControllerGoogleAuthCallbackApiArg
      >({
        query: queryArg => ({
          url: `/email-accounts/auth/google/callback`,
          params: { code: queryArg.code, state: queryArg.state, error: queryArg.error },
        }),
        providesTags: ['email-accounts:auth'],
      }),
      emailAuthControllerOutlookAuth: build.query<
        EmailAuthControllerOutlookAuthApiResponse,
        EmailAuthControllerOutlookAuthApiArg
      >({
        query: () => ({ url: `/email-accounts/auth/outlook` }),
        providesTags: ['email-accounts:auth'],
      }),
      emailAuthControllerOutlookAuthCallback: build.query<
        EmailAuthControllerOutlookAuthCallbackApiResponse,
        EmailAuthControllerOutlookAuthCallbackApiArg
      >({
        query: queryArg => ({
          url: `/email-accounts/auth/outlook/callback`,
          params: { code: queryArg.code, state: queryArg.state, error: queryArg.error },
        }),
        providesTags: ['email-accounts:auth'],
      }),
      emailAuthControllerImapSmtpCredentials: build.mutation<
        EmailAuthControllerImapSmtpCredentialsApiResponse,
        EmailAuthControllerImapSmtpCredentialsApiArg
      >({
        query: queryArg => ({
          url: `/email-accounts/auth/create/imap-smtp`,
          method: 'POST',
          body: queryArg.createImapSmtpEmailAccount,
        }),
        invalidatesTags: ['email-accounts:auth'],
      }),
      adminSharedPoolControllerGetAllPoolEmails: build.query<
        AdminSharedPoolControllerGetAllPoolEmailsApiResponse,
        AdminSharedPoolControllerGetAllPoolEmailsApiArg
      >({
        query: queryArg => ({
          url: `/admin/shared-pool/emails`,
          params: { provider: queryArg.provider, status: queryArg.status, search: queryArg.search },
        }),
      }),
      adminSharedPoolControllerAddPoolEmail: build.mutation<
        AdminSharedPoolControllerAddPoolEmailApiResponse,
        AdminSharedPoolControllerAddPoolEmailApiArg
      >({
        query: queryArg => ({ url: `/admin/shared-pool/emails`, method: 'POST', body: queryArg.addPoolEmailDto }),
      }),
      adminSharedPoolControllerGetPoolEmail: build.query<
        AdminSharedPoolControllerGetPoolEmailApiResponse,
        AdminSharedPoolControllerGetPoolEmailApiArg
      >({
        query: queryArg => ({ url: `/admin/shared-pool/emails/${queryArg.id}` }),
      }),
      adminSharedPoolControllerUpdatePoolEmail: build.mutation<
        AdminSharedPoolControllerUpdatePoolEmailApiResponse,
        AdminSharedPoolControllerUpdatePoolEmailApiArg
      >({
        query: queryArg => ({
          url: `/admin/shared-pool/emails/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.updatePoolEmailDto,
        }),
      }),
      adminSharedPoolControllerDeletePoolEmail: build.mutation<
        AdminSharedPoolControllerDeletePoolEmailApiResponse,
        AdminSharedPoolControllerDeletePoolEmailApiArg
      >({
        query: queryArg => ({ url: `/admin/shared-pool/emails/${queryArg.id}`, method: 'DELETE' }),
      }),
      adminSharedPoolControllerBulkImportPoolEmails: build.mutation<
        AdminSharedPoolControllerBulkImportPoolEmailsApiResponse,
        AdminSharedPoolControllerBulkImportPoolEmailsApiArg
      >({
        query: queryArg => ({
          url: `/admin/shared-pool/emails/bulk-import`,
          method: 'POST',
          body: queryArg.bulkImportPoolEmailDto,
        }),
      }),
      adminSharedPoolControllerActivatePoolEmail: build.mutation<
        AdminSharedPoolControllerActivatePoolEmailApiResponse,
        AdminSharedPoolControllerActivatePoolEmailApiArg
      >({
        query: queryArg => ({ url: `/admin/shared-pool/emails/${queryArg.id}/activate`, method: 'PATCH' }),
      }),
      adminSharedPoolControllerPausePoolEmail: build.mutation<
        AdminSharedPoolControllerPausePoolEmailApiResponse,
        AdminSharedPoolControllerPausePoolEmailApiArg
      >({
        query: queryArg => ({ url: `/admin/shared-pool/emails/${queryArg.id}/pause`, method: 'PATCH' }),
      }),
      adminSharedPoolControllerDisablePoolEmail: build.mutation<
        AdminSharedPoolControllerDisablePoolEmailApiResponse,
        AdminSharedPoolControllerDisablePoolEmailApiArg
      >({
        query: queryArg => ({ url: `/admin/shared-pool/emails/${queryArg.id}/disable`, method: 'PATCH' }),
      }),
      adminSharedPoolControllerTestEmailConnection: build.mutation<
        AdminSharedPoolControllerTestEmailConnectionApiResponse,
        AdminSharedPoolControllerTestEmailConnectionApiArg
      >({
        query: queryArg => ({ url: `/admin/shared-pool/emails/${queryArg.id}/test-connection`, method: 'POST' }),
      }),
      adminSharedPoolControllerGetPoolConfiguration: build.query<
        AdminSharedPoolControllerGetPoolConfigurationApiResponse,
        AdminSharedPoolControllerGetPoolConfigurationApiArg
      >({
        query: () => ({ url: `/admin/shared-pool/configuration` }),
      }),
      adminSharedPoolControllerUpdatePoolConfiguration: build.mutation<
        AdminSharedPoolControllerUpdatePoolConfigurationApiResponse,
        AdminSharedPoolControllerUpdatePoolConfigurationApiArg
      >({
        query: queryArg => ({
          url: `/admin/shared-pool/configuration`,
          method: 'PUT',
          body: queryArg.updatePoolConfigurationDto,
        }),
      }),
      adminSharedPoolControllerGetPoolStats: build.query<
        AdminSharedPoolControllerGetPoolStatsApiResponse,
        AdminSharedPoolControllerGetPoolStatsApiArg
      >({
        query: () => ({ url: `/admin/shared-pool/stats` }),
      }),
      adminSharedPoolControllerGetPoolHealth: build.query<
        AdminSharedPoolControllerGetPoolHealthApiResponse,
        AdminSharedPoolControllerGetPoolHealthApiArg
      >({
        query: () => ({ url: `/admin/shared-pool/health` }),
      }),
      adminSharedPoolControllerGetEmailDailyStats: build.query<
        AdminSharedPoolControllerGetEmailDailyStatsApiResponse,
        AdminSharedPoolControllerGetEmailDailyStatsApiArg
      >({
        query: queryArg => ({
          url: `/admin/shared-pool/emails/${queryArg.id}/daily-stats`,
          params: { days: queryArg.days },
        }),
      }),
      adminSharedPoolControllerGetPoolDailyStats: build.query<
        AdminSharedPoolControllerGetPoolDailyStatsApiResponse,
        AdminSharedPoolControllerGetPoolDailyStatsApiArg
      >({
        query: queryArg => ({ url: `/admin/shared-pool/daily-stats`, params: { days: queryArg.days } }),
      }),
      adminSharedPoolControllerGetOAuthStatus: build.query<
        AdminSharedPoolControllerGetOAuthStatusApiResponse,
        AdminSharedPoolControllerGetOAuthStatusApiArg
      >({
        query: queryArg => ({ url: `/admin/shared-pool/emails/${queryArg.id}/auth/status` }),
      }),
      adminSharedPoolControllerInitiateGoogleOAuth: build.query<
        AdminSharedPoolControllerInitiateGoogleOAuthApiResponse,
        AdminSharedPoolControllerInitiateGoogleOAuthApiArg
      >({
        query: queryArg => ({ url: `/admin/shared-pool/emails/${queryArg.id}/auth/google` }),
      }),
      adminSharedPoolControllerGoogleOAuthCallback: build.query<
        AdminSharedPoolControllerGoogleOAuthCallbackApiResponse,
        AdminSharedPoolControllerGoogleOAuthCallbackApiArg
      >({
        query: queryArg => ({
          url: `/admin/shared-pool/auth/google/callback`,
          params: { code: queryArg.code, state: queryArg.state, error: queryArg.error },
        }),
      }),
      adminSharedPoolControllerConnectOutlookClientCredentials: build.mutation<
        AdminSharedPoolControllerConnectOutlookClientCredentialsApiResponse,
        AdminSharedPoolControllerConnectOutlookClientCredentialsApiArg
      >({
        query: queryArg => ({ url: `/admin/shared-pool/emails/${queryArg.id}/auth/outlook/connect`, method: 'POST' }),
      }),
      adminSharedPoolControllerInitiateOutlookOAuth: build.query<
        AdminSharedPoolControllerInitiateOutlookOAuthApiResponse,
        AdminSharedPoolControllerInitiateOutlookOAuthApiArg
      >({
        query: queryArg => ({ url: `/admin/shared-pool/emails/${queryArg.id}/auth/outlook` }),
      }),
      adminSharedPoolControllerOutlookOAuthCallback: build.query<
        AdminSharedPoolControllerOutlookOAuthCallbackApiResponse,
        AdminSharedPoolControllerOutlookOAuthCallbackApiArg
      >({
        query: queryArg => ({
          url: `/admin/shared-pool/auth/outlook/callback`,
          params: { code: queryArg.code, state: queryArg.state, error: queryArg.error },
        }),
      }),
      adminSharedPoolControllerSetSmtpCredentials: build.mutation<
        AdminSharedPoolControllerSetSmtpCredentialsApiResponse,
        AdminSharedPoolControllerSetSmtpCredentialsApiArg
      >({
        query: queryArg => ({
          url: `/admin/shared-pool/emails/${queryArg.id}/credentials`,
          method: 'POST',
          body: queryArg.setSmtpCredentialsDto,
        }),
      }),
      adminSharedPoolControllerRefreshToken: build.mutation<
        AdminSharedPoolControllerRefreshTokenApiResponse,
        AdminSharedPoolControllerRefreshTokenApiArg
      >({
        query: queryArg => ({ url: `/admin/shared-pool/emails/${queryArg.id}/auth/refresh`, method: 'POST' }),
      }),
      userWarmupStatusControllerGetMyWarmupStatus: build.query<
        UserWarmupStatusControllerGetMyWarmupStatusApiResponse,
        UserWarmupStatusControllerGetMyWarmupStatusApiArg
      >({
        query: () => ({ url: `/warmup-pool/my-status` }),
        providesTags: ['warmup:user-status'],
      }),
      userWarmupStatusControllerGetMyWarmupInteractions: build.query<
        UserWarmupStatusControllerGetMyWarmupInteractionsApiResponse,
        UserWarmupStatusControllerGetMyWarmupInteractionsApiArg
      >({
        query: queryArg => ({
          url: `/warmup-pool/my-interactions`,
          params: {
            limit: queryArg.limit,
            offset: queryArg.offset,
            startDate: queryArg.startDate,
            endDate: queryArg.endDate,
          },
        }),
        providesTags: ['warmup:user-status'],
      }),
      userWarmupStatusControllerGetPoolStats: build.query<
        UserWarmupStatusControllerGetPoolStatsApiResponse,
        UserWarmupStatusControllerGetPoolStatsApiArg
      >({
        query: () => ({ url: `/warmup-pool/pool-stats` }),
        providesTags: ['warmup:user-status'],
      }),
      campaignControllerCreateCampaign: build.mutation<
        CampaignControllerCreateCampaignApiResponse,
        CampaignControllerCreateCampaignApiArg
      >({
        query: queryArg => ({ url: `/campaigns`, method: 'POST', body: queryArg.createCampaignDto }),
        invalidatesTags: ['campaigns'],
      }),
      campaignControllerGetAllCampaigns: build.query<
        CampaignControllerGetAllCampaignsApiResponse,
        CampaignControllerGetAllCampaignsApiArg
      >({
        query: () => ({ url: `/campaigns` }),
        providesTags: ['campaigns'],
      }),
      campaignControllerGetCampaign: build.query<
        CampaignControllerGetCampaignApiResponse,
        CampaignControllerGetCampaignApiArg
      >({
        query: queryArg => ({ url: `/campaigns/${queryArg.id}` }),
        providesTags: ['campaigns'],
      }),
      campaignControllerUpdateCampaign: build.mutation<
        CampaignControllerUpdateCampaignApiResponse,
        CampaignControllerUpdateCampaignApiArg
      >({
        query: queryArg => ({ url: `/campaigns/${queryArg.id}`, method: 'PUT', body: queryArg.updateCampaignDto }),
        invalidatesTags: ['campaigns'],
      }),
      campaignControllerDeleteCampaign: build.mutation<
        CampaignControllerDeleteCampaignApiResponse,
        CampaignControllerDeleteCampaignApiArg
      >({
        query: queryArg => ({ url: `/campaigns/${queryArg.id}`, method: 'DELETE' }),
        invalidatesTags: ['campaigns'],
      }),
      campaignControllerAddLeadsToCampaign: build.mutation<
        CampaignControllerAddLeadsToCampaignApiResponse,
        CampaignControllerAddLeadsToCampaignApiArg
      >({
        query: queryArg => ({
          url: `/campaigns/${queryArg.id}/leads`,
          method: 'PATCH',
          body: queryArg.addLeadsToCampaignDto,
        }),
        invalidatesTags: ['campaigns'],
      }),
      campaignControllerUnsubscribe: build.query<
        CampaignControllerUnsubscribeApiResponse,
        CampaignControllerUnsubscribeApiArg
      >({
        query: queryArg => ({ url: `/campaigns/${queryArg.id}/unsubscribe`, params: { leadId: queryArg.leadId } }),
        providesTags: ['campaigns'],
      }),
      campaignControllerUpdateCampaignDetails: build.mutation<
        CampaignControllerUpdateCampaignDetailsApiResponse,
        CampaignControllerUpdateCampaignDetailsApiArg
      >({
        query: queryArg => ({
          url: `/campaigns/${queryArg.id}/details`,
          method: 'PUT',
          body: queryArg.updateCampaignDetailsDto,
        }),
        invalidatesTags: ['campaigns'],
      }),
      campaignControllerPatchCampaignStatus: build.mutation<
        CampaignControllerPatchCampaignStatusApiResponse,
        CampaignControllerPatchCampaignStatusApiArg
      >({
        query: queryArg => ({
          url: `/campaigns/${queryArg.id}/status`,
          method: 'PATCH',
          body: queryArg.patchCampaignStatusDto,
        }),
        invalidatesTags: ['campaigns'],
      }),
      campaignControllerGetEmailAccountsForCampaign: build.query<
        CampaignControllerGetEmailAccountsForCampaignApiResponse,
        CampaignControllerGetEmailAccountsForCampaignApiArg
      >({
        query: queryArg => ({ url: `/campaigns/${queryArg.id}/email-accounts` }),
        providesTags: ['campaigns'],
      }),
      campaignControllerAddEmailAccountToCampaign: build.mutation<
        CampaignControllerAddEmailAccountToCampaignApiResponse,
        CampaignControllerAddEmailAccountToCampaignApiArg
      >({
        query: queryArg => ({
          url: `/campaigns/${queryArg.id}/email-accounts`,
          method: 'POST',
          body: queryArg.addEmailAccountToCampaignDto,
        }),
        invalidatesTags: ['campaigns'],
      }),
      campaignControllerRemoveEmailAccountFromCampaign: build.mutation<
        CampaignControllerRemoveEmailAccountFromCampaignApiResponse,
        CampaignControllerRemoveEmailAccountFromCampaignApiArg
      >({
        query: queryArg => ({
          url: `/campaigns/${queryArg.id}/email-accounts`,
          method: 'DELETE',
          body: queryArg.removeEmailAccountDto,
        }),
        invalidatesTags: ['campaigns'],
      }),
      campaignSequenceControllerGetSequences: build.query<
        CampaignSequenceControllerGetSequencesApiResponse,
        CampaignSequenceControllerGetSequencesApiArg
      >({
        query: queryArg => ({ url: `/campaigns/${queryArg.campaignId}/sequence` }),
        providesTags: ['campaigns:sequence'],
      }),
      campaignSequenceControllerAddSequence: build.mutation<
        CampaignSequenceControllerAddSequenceApiResponse,
        CampaignSequenceControllerAddSequenceApiArg
      >({
        query: queryArg => ({
          url: `/campaigns/${queryArg.campaignId}/sequence`,
          method: 'POST',
          body: queryArg.sequenceDto,
        }),
        invalidatesTags: ['campaigns:sequence'],
      }),
      campaignSequenceControllerFetchCampaignSequence: build.query<
        CampaignSequenceControllerFetchCampaignSequenceApiResponse,
        CampaignSequenceControllerFetchCampaignSequenceApiArg
      >({
        query: queryArg => ({ url: `/campaigns/${queryArg.campaignId}/sequence/${queryArg.sequenceId}` }),
        providesTags: ['campaigns:sequence'],
      }),
      campaignSequenceControllerUpdateSequence: build.mutation<
        CampaignSequenceControllerUpdateSequenceApiResponse,
        CampaignSequenceControllerUpdateSequenceApiArg
      >({
        query: queryArg => ({
          url: `/campaigns/${queryArg.campaignId}/sequence/${queryArg.sequenceId}`,
          method: 'PUT',
          body: queryArg.sequenceDto,
        }),
        invalidatesTags: ['campaigns:sequence'],
      }),
      campaignSequenceControllerDeleteSequence: build.mutation<
        CampaignSequenceControllerDeleteSequenceApiResponse,
        CampaignSequenceControllerDeleteSequenceApiArg
      >({
        query: queryArg => ({
          url: `/campaigns/${queryArg.campaignId}/sequence/${queryArg.sequenceId}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['campaigns:sequence'],
      }),
      campaignAnalyticControllerGetAnalyticsOverview: build.query<
        CampaignAnalyticControllerGetAnalyticsOverviewApiResponse,
        CampaignAnalyticControllerGetAnalyticsOverviewApiArg
      >({
        query: queryArg => ({
          url: `/analytics/overview`,
          params: { startDate: queryArg.startDate, endDate: queryArg.endDate, includeWarmup: queryArg.includeWarmup },
        }),
        providesTags: ['campaigns:analytics'],
      }),
      campaignAnalyticControllerGetAnalyticsTimeSeries: build.query<
        CampaignAnalyticControllerGetAnalyticsTimeSeriesApiResponse,
        CampaignAnalyticControllerGetAnalyticsTimeSeriesApiArg
      >({
        query: queryArg => ({
          url: `/analytics/overview/timeseries`,
          params: { startDate: queryArg.startDate, endDate: queryArg.endDate, includeWarmup: queryArg.includeWarmup },
        }),
        providesTags: ['campaigns:analytics'],
      }),
      campaignAnalyticControllerGetCampaignAnalytics: build.query<
        CampaignAnalyticControllerGetCampaignAnalyticsApiResponse,
        CampaignAnalyticControllerGetCampaignAnalyticsApiArg
      >({
        query: queryArg => ({
          url: `/analytics/${queryArg.id}`,
          params: { startDate: queryArg.startDate, endDate: queryArg.endDate },
        }),
        providesTags: ['campaigns:analytics'],
      }),
      campaignAnalyticControllerExportCampaignData: build.query<
        CampaignAnalyticControllerExportCampaignDataApiResponse,
        CampaignAnalyticControllerExportCampaignDataApiArg
      >({
        query: queryArg => ({ url: `/analytics/${queryArg.id}/export` }),
        providesTags: ['campaigns:analytics'],
      }),
      campaignExecutionControllerExecuteCampaign: build.mutation<
        CampaignExecutionControllerExecuteCampaignApiResponse,
        CampaignExecutionControllerExecuteCampaignApiArg
      >({
        query: queryArg => ({
          url: `/campaigns/${queryArg.id}/schedule-execution`,
          method: 'POST',
          body: queryArg.executeCampaignDto,
        }),
        invalidatesTags: ['campaigns'],
      }),
      campaignExecutionControllerUpdateStatistics: build.mutation<
        CampaignExecutionControllerUpdateStatisticsApiResponse,
        CampaignExecutionControllerUpdateStatisticsApiArg
      >({
        query: queryArg => ({ url: `/campaigns/${queryArg.id}/update-statistics`, method: 'POST' }),
        invalidatesTags: ['campaigns'],
      }),
      campaignExecutionControllerTrackClickAndRedirect: build.query<
        CampaignExecutionControllerTrackClickAndRedirectApiResponse,
        CampaignExecutionControllerTrackClickAndRedirectApiArg
      >({
        query: queryArg => ({
          url: `/campaigns/track-clicked/${queryArg.campaignExecutionId}`,
          params: { originalUrl: queryArg.originalUrl },
        }),
        providesTags: ['campaigns'],
      }),
      campaignExecutionControllerTrackOpened: build.query<
        CampaignExecutionControllerTrackOpenedApiResponse,
        CampaignExecutionControllerTrackOpenedApiArg
      >({
        query: queryArg => ({ url: `/campaigns/track-opened/${queryArg.campaignExecutionId}.png` }),
        providesTags: ['campaigns'],
      }),
      campaignTrackingControllerTrackOpened: build.query<
        CampaignTrackingControllerTrackOpenedApiResponse,
        CampaignTrackingControllerTrackOpenedApiArg
      >({
        query: queryArg => ({ url: `/image`, params: { campaignExecutionId: queryArg.campaignExecutionId } }),
        providesTags: ['image'],
      }),
      webhookControllerCreateOrUpdateWebhook: build.mutation<
        WebhookControllerCreateOrUpdateWebhookApiResponse,
        WebhookControllerCreateOrUpdateWebhookApiArg
      >({
        query: queryArg => ({ url: `/campaign-webhooks`, method: 'POST' }),
        invalidatesTags: ['webhooks'],
      }),
      webhookControllerGetWebhooksByCampaign: build.query<
        WebhookControllerGetWebhooksByCampaignApiResponse,
        WebhookControllerGetWebhooksByCampaignApiArg
      >({
        query: queryArg => ({ url: `/campaign-webhooks` }),
        providesTags: ['webhooks'],
      }),
      webhookControllerDeleteWebhook: build.mutation<
        WebhookControllerDeleteWebhookApiResponse,
        WebhookControllerDeleteWebhookApiArg
      >({
        query: queryArg => ({ url: `/campaign-webhooks/${queryArg.webhookId}`, method: 'DELETE' }),
        invalidatesTags: ['webhooks'],
      }),
      webhookControllerGetWebhookLogs: build.query<
        WebhookControllerGetWebhookLogsApiResponse,
        WebhookControllerGetWebhookLogsApiArg
      >({
        query: queryArg => ({
          url: `/campaign-webhooks/${queryArg.webhookId}/logs`,
          params: { limit: queryArg.limit, offset: queryArg.offset },
        }),
        providesTags: ['webhooks'],
      }),
      leadControllerGetAllLeads: build.query<LeadControllerGetAllLeadsApiResponse, LeadControllerGetAllLeadsApiArg>({
        query: queryArg => ({
          url: `/leads`,
          params: {
            offset: queryArg.offset,
            limit: queryArg.limit,
            created_at_gt: queryArg.createdAtGt,
            email: queryArg.email,
            clientId: queryArg.clientId,
          },
        }),
        providesTags: ['leads'],
      }),
      leadControllerCreateLead: build.mutation<LeadControllerCreateLeadApiResponse, LeadControllerCreateLeadApiArg>({
        query: queryArg => ({ url: `/leads`, method: 'POST', body: queryArg.createLeadDto }),
        invalidatesTags: ['leads'],
      }),
      leadControllerImportCsv: build.mutation<LeadControllerImportCsvApiResponse, LeadControllerImportCsvApiArg>({
        query: queryArg => ({ url: `/leads/import-csv`, method: 'POST', body: queryArg.csvImportMappingDto }),
        invalidatesTags: ['leads'],
      }),
      leadControllerGetLead: build.query<LeadControllerGetLeadApiResponse, LeadControllerGetLeadApiArg>({
        query: queryArg => ({ url: `/leads/${queryArg.id}` }),
        providesTags: ['leads'],
      }),
      leadControllerUpdateLead: build.mutation<LeadControllerUpdateLeadApiResponse, LeadControllerUpdateLeadApiArg>({
        query: queryArg => ({ url: `/leads/${queryArg.id}`, method: 'PATCH', body: queryArg.updateLeadDto }),
        invalidatesTags: ['leads'],
      }),
      leadControllerDeleteLead: build.mutation<LeadControllerDeleteLeadApiResponse, LeadControllerDeleteLeadApiArg>({
        query: queryArg => ({ url: `/leads/${queryArg.id}`, method: 'DELETE' }),
        invalidatesTags: ['leads'],
      }),
      leadControllerGetLeadsByEmail: build.query<
        LeadControllerGetLeadsByEmailApiResponse,
        LeadControllerGetLeadsByEmailApiArg
      >({
        query: queryArg => ({ url: `/leads/email/${queryArg.email}` }),
        providesTags: ['leads'],
      }),
      leadControllerGetLeadCategories: build.query<
        LeadControllerGetLeadCategoriesApiResponse,
        LeadControllerGetLeadCategoriesApiArg
      >({
        query: () => ({ url: `/leads/categories` }),
        providesTags: ['leads'],
      }),
      leadControllerUpdateLeadCategory: build.mutation<
        LeadControllerUpdateLeadCategoryApiResponse,
        LeadControllerUpdateLeadCategoryApiArg
      >({
        query: queryArg => ({ url: `/leads/${queryArg.id}/category/${queryArg.categoryId}`, method: 'PATCH' }),
        invalidatesTags: ['leads'],
      }),
      leadControllerGetLeadsFromGlobalBlockList: build.query<
        LeadControllerGetLeadsFromGlobalBlockListApiResponse,
        LeadControllerGetLeadsFromGlobalBlockListApiArg
      >({
        query: queryArg => ({
          url: `/leads/global-block-list`,
          params: {
            offset: queryArg.offset,
            limit: queryArg.limit,
            created_at_gt: queryArg.createdAtGt,
            email: queryArg.email,
            clientId: queryArg.clientId,
          },
        }),
        providesTags: ['leads'],
      }),
      leadControllerAddToGlobalBlockList: build.mutation<
        LeadControllerAddToGlobalBlockListApiResponse,
        LeadControllerAddToGlobalBlockListApiArg
      >({
        query: queryArg => ({ url: `/leads/block-list`, method: 'POST', body: queryArg.addToBlockListDto }),
        invalidatesTags: ['leads'],
      }),
      leadControllerAddLeadToGlobalBlockList: build.mutation<
        LeadControllerAddLeadToGlobalBlockListApiResponse,
        LeadControllerAddLeadToGlobalBlockListApiArg
      >({
        query: queryArg => ({ url: `/leads/${queryArg.id}/block`, method: 'POST' }),
        invalidatesTags: ['leads'],
      }),
      statisticsControllerGetCampaignStatistics: build.query<
        StatisticsControllerGetCampaignStatisticsApiResponse,
        StatisticsControllerGetCampaignStatisticsApiArg
      >({
        query: queryArg => ({
          url: `/statistics/campaigns/${queryArg.campaignId}`,
          params: { startDate: queryArg.startDate, endDate: queryArg.endDate },
        }),
        providesTags: ['statistics'],
      }),
      statisticsControllerGetCampaignLeadStatistics: build.query<
        StatisticsControllerGetCampaignLeadStatisticsApiResponse,
        StatisticsControllerGetCampaignLeadStatisticsApiArg
      >({
        query: queryArg => ({
          url: `/statistics/campaigns/${queryArg.campaignId}/lead-statistics`,
          params: { offset: queryArg.offset, limit: queryArg.limit },
        }),
        providesTags: ['statistics'],
      }),
      statisticsControllerGetCampaignMailboxStatistics: build.query<
        StatisticsControllerGetCampaignMailboxStatisticsApiResponse,
        StatisticsControllerGetCampaignMailboxStatisticsApiArg
      >({
        query: queryArg => ({ url: `/statistics/campaigns/${queryArg.campaignId}/mailbox-statistics` }),
        providesTags: ['statistics'],
      }),
      statisticsControllerGetEmailAccountWarmupStats: build.query<
        StatisticsControllerGetEmailAccountWarmupStatsApiResponse,
        StatisticsControllerGetEmailAccountWarmupStatsApiArg
      >({
        query: queryArg => ({ url: `/statistics/email-accounts/${queryArg.emailAccountId}/warmup-stats` }),
        providesTags: ['statistics'],
      }),
      statisticsControllerGetMasterInboxStatistics: build.query<
        StatisticsControllerGetMasterInboxStatisticsApiResponse,
        StatisticsControllerGetMasterInboxStatisticsApiArg
      >({
        query: queryArg => ({
          url: `/statistics/master-inbox`,
          params: { startDate: queryArg.startDate, endDate: queryArg.endDate },
        }),
        providesTags: ['statistics'],
      }),
      masterInboxControllerGetAllThreadsByClientId: build.query<
        MasterInboxControllerGetAllThreadsByClientIdApiResponse,
        MasterInboxControllerGetAllThreadsByClientIdApiArg
      >({
        query: queryArg => ({
          url: `/master-inbox`,
          params: {
            boxName: queryArg.boxName,
            accountId: queryArg.accountId,
            limit: queryArg.limit,
            includeWarmup: queryArg.includeWarmup,
          },
        }),
        providesTags: ['master-inbox'],
      }),
      masterInboxControllerGetEmailThread: build.query<
        MasterInboxControllerGetEmailThreadApiResponse,
        MasterInboxControllerGetEmailThreadApiArg
      >({
        query: queryArg => ({
          url: `/master-inbox/thread`,
          params: { accountId: queryArg.accountId, initialMessageId: queryArg.initialMessageId },
        }),
        providesTags: ['master-inbox'],
      }),
      masterInboxControllerReplyWithAttachment: build.mutation<
        MasterInboxControllerReplyWithAttachmentApiResponse,
        MasterInboxControllerReplyWithAttachmentApiArg
      >({
        query: queryArg => ({ url: `/master-inbox/reply`, method: 'POST', body: queryArg.replyDto }),
        invalidatesTags: ['master-inbox'],
      }),
      customDomainsControllerSuggestDomains: build.mutation<
        CustomDomainsControllerSuggestDomainsApiResponse,
        CustomDomainsControllerSuggestDomainsApiArg
      >({
        query: queryArg => ({ url: `/custom-domains/suggestions`, method: 'POST', body: queryArg.suggestDomainsDto }),
        invalidatesTags: ['custom-domains'],
      }),
      customDomainsControllerCheckAvailability: build.mutation<
        CustomDomainsControllerCheckAvailabilityApiResponse,
        CustomDomainsControllerCheckAvailabilityApiArg
      >({
        query: () => ({ url: `/custom-domains/check-availability`, method: 'POST' }),
        invalidatesTags: ['custom-domains'],
      }),
      customDomainsControllerCheckAvailabilityBatch: build.mutation<
        CustomDomainsControllerCheckAvailabilityBatchApiResponse,
        CustomDomainsControllerCheckAvailabilityBatchApiArg
      >({
        query: () => ({ url: `/custom-domains/check-availability-batch`, method: 'POST' }),
        invalidatesTags: ['custom-domains'],
      }),
      customDomainsControllerPurchaseDomains: build.mutation<
        CustomDomainsControllerPurchaseDomainsApiResponse,
        CustomDomainsControllerPurchaseDomainsApiArg
      >({
        query: queryArg => ({ url: `/custom-domains/purchase`, method: 'POST', body: queryArg.purchaseDomainsDto }),
        invalidatesTags: ['custom-domains'],
      }),
      customDomainsControllerGetMyDomains: build.query<
        CustomDomainsControllerGetMyDomainsApiResponse,
        CustomDomainsControllerGetMyDomainsApiArg
      >({
        query: () => ({ url: `/custom-domains` }),
        providesTags: ['custom-domains'],
      }),
      customDomainsControllerGetDomainDetails: build.query<
        CustomDomainsControllerGetDomainDetailsApiResponse,
        CustomDomainsControllerGetDomainDetailsApiArg
      >({
        query: queryArg => ({ url: `/custom-domains/${queryArg.id}` }),
        providesTags: ['custom-domains'],
      }),
      customDomainsControllerVerifyDns: build.mutation<
        CustomDomainsControllerVerifyDnsApiResponse,
        CustomDomainsControllerVerifyDnsApiArg
      >({
        query: queryArg => ({ url: `/custom-domains/${queryArg.id}/verify-dns`, method: 'POST' }),
        invalidatesTags: ['custom-domains'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as emailServiceApi };
export type EmailAccountControllerGetAllEmailAccountsApiResponse = /** status 200  */ EmailAccountListDto;
export type EmailAccountControllerGetAllEmailAccountsApiArg = {
  username?: string;
  offset?: number;
  limit?: number;
};
export type EmailAccountControllerGetEmailAccountApiResponse = unknown;
export type EmailAccountControllerGetEmailAccountApiArg = {
  id: string;
};
export type EmailAccountControllerUpdateEmailAccountApiResponse = unknown;
export type EmailAccountControllerUpdateEmailAccountApiArg = {
  id: string;
  updateEmailAccountDto: UpdateEmailAccountDto;
};
export type EmailAccountControllerDeleteEmailAccountApiResponse = unknown;
export type EmailAccountControllerDeleteEmailAccountApiArg = {
  id: string;
};
export type EmailAccountControllerTestConnectionApiResponse = unknown;
export type EmailAccountControllerTestConnectionApiArg = {
  id: string;
};
export type EmailAccountControllerGetWarmupStatusApiResponse = unknown;
export type EmailAccountControllerGetWarmupStatusApiArg = {
  id: string;
};
export type EmailAccountControllerStartWarmupApiResponse = unknown;
export type EmailAccountControllerStartWarmupApiArg = {
  id: string;
};
export type EmailAccountControllerPauseWarmupApiResponse = /** status 200 Warmup paused successfully. */
  | void
  | /** status 201  */ object;
export type EmailAccountControllerPauseWarmupApiArg = {
  id: string;
};
export type WarmupPoolControllerCreateWarmupPoolApiResponse = unknown;
export type WarmupPoolControllerCreateWarmupPoolApiArg = void;
export type WarmupPoolControllerAddToWarmupPoolApiResponse = unknown;
export type WarmupPoolControllerAddToWarmupPoolApiArg = {
  id: string;
  emailAccountWarmupPoolDto: EmailAccountWarmupPoolDto;
};
export type WarmupPoolControllerRemoveFromWarmupPoolApiResponse = unknown;
export type WarmupPoolControllerRemoveFromWarmupPoolApiArg = {
  id: string;
  /** Email to remove from the pool */
  email: string;
  emailAccountWarmupPoolDto: EmailAccountWarmupPoolDto;
};
export type WarmupPoolControllerGetWarmupPoolApiResponse = /** status 200  */ object[];
export type WarmupPoolControllerGetWarmupPoolApiArg = {
  id: string;
};
export type WarmupProfileControllerGetActiveWarmupProfilesApiResponse = unknown;
export type WarmupProfileControllerGetActiveWarmupProfilesApiArg = void;
export type WarmupProfileControllerGetAllWarmupProfilesApiResponse = /** status 200  */ WarmupClassDto;
export type WarmupProfileControllerGetAllWarmupProfilesApiArg = void;
export type WarmupProfileControllerUpsertWarmupProfileApiResponse = unknown;
export type WarmupProfileControllerUpsertWarmupProfileApiArg = {
  addWarmupDto: AddWarmupDto;
};
export type WarmupProfileControllerGetWarmupStatsApiResponse = unknown;
export type WarmupProfileControllerGetWarmupStatsApiArg = {
  id: string;
  startDate: string;
  endDate: string;
};
export type WarmupProfileControllerExecuteInboxVerificationApiResponse = unknown;
export type WarmupProfileControllerExecuteInboxVerificationApiArg = {
  id: string;
};
export type WarmupProfileControllerExecuteWarmupApiResponse = unknown;
export type WarmupProfileControllerExecuteWarmupApiArg = {
  executeWarmupDto: ExecuteWarmupDto;
};
export type EmailAuthControllerGoogleAuthApiResponse = /** status 200  */ OutlookAuthInitDto;
export type EmailAuthControllerGoogleAuthApiArg = void;
export type EmailAuthControllerGoogleAuthCallbackApiResponse = unknown;
export type EmailAuthControllerGoogleAuthCallbackApiArg = {
  code: string;
  state: string;
  error: string;
};
export type EmailAuthControllerOutlookAuthApiResponse = /** status 200  */ OutlookAuthInitDto;
export type EmailAuthControllerOutlookAuthApiArg = void;
export type EmailAuthControllerOutlookAuthCallbackApiResponse = unknown;
export type EmailAuthControllerOutlookAuthCallbackApiArg = {
  code: string;
  state: string;
  error: string;
};
export type EmailAuthControllerImapSmtpCredentialsApiResponse = unknown;
export type EmailAuthControllerImapSmtpCredentialsApiArg = {
  createImapSmtpEmailAccount: CreateImapSmtpEmailAccount;
};
export type AdminSharedPoolControllerGetAllPoolEmailsApiResponse = /** status 200  */ object[];
export type AdminSharedPoolControllerGetAllPoolEmailsApiArg = {
  provider: string;
  status: string;
  search: string;
};
export type AdminSharedPoolControllerAddPoolEmailApiResponse = unknown;
export type AdminSharedPoolControllerAddPoolEmailApiArg = {
  addPoolEmailDto: AddPoolEmailDto;
};
export type AdminSharedPoolControllerGetPoolEmailApiResponse = /** status 200  */ object;
export type AdminSharedPoolControllerGetPoolEmailApiArg = {
  id: string;
};
export type AdminSharedPoolControllerUpdatePoolEmailApiResponse = unknown;
export type AdminSharedPoolControllerUpdatePoolEmailApiArg = {
  id: string;
  updatePoolEmailDto: UpdatePoolEmailDto;
};
export type AdminSharedPoolControllerDeletePoolEmailApiResponse = unknown;
export type AdminSharedPoolControllerDeletePoolEmailApiArg = {
  id: string;
};
export type AdminSharedPoolControllerBulkImportPoolEmailsApiResponse = unknown;
export type AdminSharedPoolControllerBulkImportPoolEmailsApiArg = {
  bulkImportPoolEmailDto: BulkImportPoolEmailDto;
};
export type AdminSharedPoolControllerActivatePoolEmailApiResponse = unknown;
export type AdminSharedPoolControllerActivatePoolEmailApiArg = {
  id: string;
};
export type AdminSharedPoolControllerPausePoolEmailApiResponse = unknown;
export type AdminSharedPoolControllerPausePoolEmailApiArg = {
  id: string;
};
export type AdminSharedPoolControllerDisablePoolEmailApiResponse = unknown;
export type AdminSharedPoolControllerDisablePoolEmailApiArg = {
  id: string;
};
export type AdminSharedPoolControllerTestEmailConnectionApiResponse = unknown;
export type AdminSharedPoolControllerTestEmailConnectionApiArg = {
  id: string;
};
export type AdminSharedPoolControllerGetPoolConfigurationApiResponse = unknown;
export type AdminSharedPoolControllerGetPoolConfigurationApiArg = void;
export type AdminSharedPoolControllerUpdatePoolConfigurationApiResponse = unknown;
export type AdminSharedPoolControllerUpdatePoolConfigurationApiArg = {
  updatePoolConfigurationDto: UpdatePoolConfigurationDto;
};
export type AdminSharedPoolControllerGetPoolStatsApiResponse = unknown;
export type AdminSharedPoolControllerGetPoolStatsApiArg = void;
export type AdminSharedPoolControllerGetPoolHealthApiResponse = unknown;
export type AdminSharedPoolControllerGetPoolHealthApiArg = void;
export type AdminSharedPoolControllerGetEmailDailyStatsApiResponse = unknown;
export type AdminSharedPoolControllerGetEmailDailyStatsApiArg = {
  id: string;
  days: string;
};
export type AdminSharedPoolControllerGetPoolDailyStatsApiResponse = unknown;
export type AdminSharedPoolControllerGetPoolDailyStatsApiArg = {
  days: string;
};
export type AdminSharedPoolControllerGetOAuthStatusApiResponse = unknown;
export type AdminSharedPoolControllerGetOAuthStatusApiArg = {
  id: string;
};
export type AdminSharedPoolControllerInitiateGoogleOAuthApiResponse = unknown;
export type AdminSharedPoolControllerInitiateGoogleOAuthApiArg = {
  id: string;
};
export type AdminSharedPoolControllerGoogleOAuthCallbackApiResponse = unknown;
export type AdminSharedPoolControllerGoogleOAuthCallbackApiArg = {
  code: string;
  state: string;
  error: string;
};
export type AdminSharedPoolControllerConnectOutlookClientCredentialsApiResponse = unknown;
export type AdminSharedPoolControllerConnectOutlookClientCredentialsApiArg = {
  id: string;
};
export type AdminSharedPoolControllerInitiateOutlookOAuthApiResponse = unknown;
export type AdminSharedPoolControllerInitiateOutlookOAuthApiArg = {
  id: string;
};
export type AdminSharedPoolControllerOutlookOAuthCallbackApiResponse = unknown;
export type AdminSharedPoolControllerOutlookOAuthCallbackApiArg = {
  code: string;
  state: string;
  error: string;
};
export type AdminSharedPoolControllerSetSmtpCredentialsApiResponse = unknown;
export type AdminSharedPoolControllerSetSmtpCredentialsApiArg = {
  id: string;
  setSmtpCredentialsDto: SetSmtpCredentialsDto;
};
export type AdminSharedPoolControllerRefreshTokenApiResponse = /** status 201  */ object;
export type AdminSharedPoolControllerRefreshTokenApiArg = {
  id: string;
};
export type UserWarmupStatusControllerGetMyWarmupStatusApiResponse = unknown;
export type UserWarmupStatusControllerGetMyWarmupStatusApiArg = void;
export type UserWarmupStatusControllerGetMyWarmupInteractionsApiResponse = unknown;
export type UserWarmupStatusControllerGetMyWarmupInteractionsApiArg = {
  limit: string;
  offset: string;
  startDate: string;
  endDate: string;
};
export type UserWarmupStatusControllerGetPoolStatsApiResponse = unknown;
export type UserWarmupStatusControllerGetPoolStatsApiArg = void;
export type CampaignControllerCreateCampaignApiResponse = unknown;
export type CampaignControllerCreateCampaignApiArg = {
  createCampaignDto: CreateCampaignDto;
};
export type CampaignControllerGetAllCampaignsApiResponse = /** status 200  */ CampaignListDto;
export type CampaignControllerGetAllCampaignsApiArg = void;
export type CampaignControllerGetCampaignApiResponse = /** status 200  */ CampaignDto;
export type CampaignControllerGetCampaignApiArg = {
  id: string;
};
export type CampaignControllerUpdateCampaignApiResponse = unknown;
export type CampaignControllerUpdateCampaignApiArg = {
  id: string;
  updateCampaignDto: UpdateCampaignDto;
};
export type CampaignControllerDeleteCampaignApiResponse = unknown;
export type CampaignControllerDeleteCampaignApiArg = {
  id: string;
};
export type CampaignControllerAddLeadsToCampaignApiResponse = unknown;
export type CampaignControllerAddLeadsToCampaignApiArg = {
  id: string;
  addLeadsToCampaignDto: AddLeadsToCampaignDto;
};
export type CampaignControllerUnsubscribeApiResponse = unknown;
export type CampaignControllerUnsubscribeApiArg = {
  id: string;
  leadId: string;
};
export type CampaignControllerUpdateCampaignDetailsApiResponse = unknown;
export type CampaignControllerUpdateCampaignDetailsApiArg = {
  id: string;
  updateCampaignDetailsDto: UpdateCampaignDetailsDto;
};
export type CampaignControllerPatchCampaignStatusApiResponse = unknown;
export type CampaignControllerPatchCampaignStatusApiArg = {
  id: string;
  patchCampaignStatusDto: PatchCampaignStatusDto;
};
export type CampaignControllerGetEmailAccountsForCampaignApiResponse = unknown;
export type CampaignControllerGetEmailAccountsForCampaignApiArg = {
  id: string;
};
export type CampaignControllerAddEmailAccountToCampaignApiResponse = unknown;
export type CampaignControllerAddEmailAccountToCampaignApiArg = {
  id: string;
  addEmailAccountToCampaignDto: AddEmailAccountToCampaignDto;
};
export type CampaignControllerRemoveEmailAccountFromCampaignApiResponse = unknown;
export type CampaignControllerRemoveEmailAccountFromCampaignApiArg = {
  id: string;
  removeEmailAccountDto: RemoveEmailAccountDto;
};
export type CampaignSequenceControllerGetSequencesApiResponse = unknown;
export type CampaignSequenceControllerGetSequencesApiArg = {
  campaignId: string;
};
export type CampaignSequenceControllerAddSequenceApiResponse = unknown;
export type CampaignSequenceControllerAddSequenceApiArg = {
  campaignId: string;
  sequenceDto: SequenceDto;
};
export type CampaignSequenceControllerFetchCampaignSequenceApiResponse = unknown;
export type CampaignSequenceControllerFetchCampaignSequenceApiArg = {
  campaignId: string;
  sequenceId: string;
};
export type CampaignSequenceControllerUpdateSequenceApiResponse = unknown;
export type CampaignSequenceControllerUpdateSequenceApiArg = {
  campaignId: string;
  sequenceId: string;
  sequenceDto: SequenceDto;
};
export type CampaignSequenceControllerDeleteSequenceApiResponse = unknown;
export type CampaignSequenceControllerDeleteSequenceApiArg = {
  campaignId: string;
  sequenceId: string;
};
export type CampaignAnalyticControllerGetAnalyticsOverviewApiResponse = unknown;
export type CampaignAnalyticControllerGetAnalyticsOverviewApiArg = {
  startDate?: string;
  endDate?: string;
  /** Include warmup stats in the overview (default: true) */
  includeWarmup?: boolean;
};
export type CampaignAnalyticControllerGetAnalyticsTimeSeriesApiResponse = unknown;
export type CampaignAnalyticControllerGetAnalyticsTimeSeriesApiArg = {
  startDate?: string;
  endDate?: string;
  /** Include warmup stats (default: true) */
  includeWarmup?: boolean;
};
export type CampaignAnalyticControllerGetCampaignAnalyticsApiResponse = unknown;
export type CampaignAnalyticControllerGetCampaignAnalyticsApiArg = {
  id: string;
  startDate: string;
  endDate: string;
};
export type CampaignAnalyticControllerExportCampaignDataApiResponse = unknown;
export type CampaignAnalyticControllerExportCampaignDataApiArg = {
  id: string;
};
export type CampaignExecutionControllerExecuteCampaignApiResponse = unknown;
export type CampaignExecutionControllerExecuteCampaignApiArg = {
  id: string;
  executeCampaignDto: ExecuteCampaignDto;
};
export type CampaignExecutionControllerUpdateStatisticsApiResponse = unknown;
export type CampaignExecutionControllerUpdateStatisticsApiArg = {
  id: string;
};
export type CampaignExecutionControllerTrackClickAndRedirectApiResponse = unknown;
export type CampaignExecutionControllerTrackClickAndRedirectApiArg = {
  campaignExecutionId: string;
  originalUrl: string;
};
export type CampaignExecutionControllerTrackOpenedApiResponse = unknown;
export type CampaignExecutionControllerTrackOpenedApiArg = {
  campaignExecutionId: string;
};
export type CampaignTrackingControllerTrackOpenedApiResponse = unknown;
export type CampaignTrackingControllerTrackOpenedApiArg = {
  campaignExecutionId: string;
};
export type WebhookControllerCreateOrUpdateWebhookApiResponse = unknown;
export type WebhookControllerCreateOrUpdateWebhookApiArg = {
  campaignId: string;
};
export type WebhookControllerGetWebhooksByCampaignApiResponse = unknown;
export type WebhookControllerGetWebhooksByCampaignApiArg = {
  campaignId: string;
};
export type WebhookControllerDeleteWebhookApiResponse = unknown;
export type WebhookControllerDeleteWebhookApiArg = {
  campaignId: string;
  webhookId: string;
};
export type WebhookControllerGetWebhookLogsApiResponse = unknown;
export type WebhookControllerGetWebhookLogsApiArg = {
  webhookId: string;
  limit: number;
  offset: number;
};
export type LeadControllerGetAllLeadsApiResponse = unknown;
export type LeadControllerGetAllLeadsApiArg = {
  offset?: number;
  limit?: number;
  createdAtGt?: string;
  email?: string;
  clientId?: string;
};
export type LeadControllerCreateLeadApiResponse = unknown;
export type LeadControllerCreateLeadApiArg = {
  createLeadDto: CreateLeadDto;
};
export type LeadControllerImportCsvApiResponse = /** status 201  */ LeadCsvImportResultDto;
export type LeadControllerImportCsvApiArg = {
  csvImportMappingDto: CsvImportMappingDto;
};
export type LeadControllerGetLeadApiResponse = unknown;
export type LeadControllerGetLeadApiArg = {
  id: string;
};
export type LeadControllerUpdateLeadApiResponse = unknown;
export type LeadControllerUpdateLeadApiArg = {
  id: string;
  updateLeadDto: UpdateLeadDto;
};
export type LeadControllerDeleteLeadApiResponse = unknown;
export type LeadControllerDeleteLeadApiArg = {
  id: string;
};
export type LeadControllerGetLeadsByEmailApiResponse = unknown;
export type LeadControllerGetLeadsByEmailApiArg = {
  email: string;
};
export type LeadControllerGetLeadCategoriesApiResponse = unknown;
export type LeadControllerGetLeadCategoriesApiArg = void;
export type LeadControllerUpdateLeadCategoryApiResponse = unknown;
export type LeadControllerUpdateLeadCategoryApiArg = {
  id: string;
  categoryId: string;
};
export type LeadControllerGetLeadsFromGlobalBlockListApiResponse = unknown;
export type LeadControllerGetLeadsFromGlobalBlockListApiArg = {
  offset?: number;
  limit?: number;
  createdAtGt?: string;
  email?: string;
  clientId?: string;
};
export type LeadControllerAddToGlobalBlockListApiResponse = unknown;
export type LeadControllerAddToGlobalBlockListApiArg = {
  addToBlockListDto: AddToBlockListDto;
};
export type LeadControllerAddLeadToGlobalBlockListApiResponse = unknown;
export type LeadControllerAddLeadToGlobalBlockListApiArg = {
  id: string;
};
export type StatisticsControllerGetCampaignStatisticsApiResponse = unknown;
export type StatisticsControllerGetCampaignStatisticsApiArg = {
  campaignId: string;
  startDate?: string;
  endDate?: string;
};
export type StatisticsControllerGetCampaignLeadStatisticsApiResponse = unknown;
export type StatisticsControllerGetCampaignLeadStatisticsApiArg = {
  campaignId: string;
  offset?: number;
  limit?: number;
};
export type StatisticsControllerGetCampaignMailboxStatisticsApiResponse = unknown;
export type StatisticsControllerGetCampaignMailboxStatisticsApiArg = {
  campaignId: string;
};
export type StatisticsControllerGetEmailAccountWarmupStatsApiResponse = unknown;
export type StatisticsControllerGetEmailAccountWarmupStatsApiArg = {
  emailAccountId: string;
};
export type StatisticsControllerGetMasterInboxStatisticsApiResponse = unknown;
export type StatisticsControllerGetMasterInboxStatisticsApiArg = {
  startDate?: string;
  endDate?: string;
};
export type MasterInboxControllerGetAllThreadsByClientIdApiResponse = /** status 200  */ EmailBoxDto;
export type MasterInboxControllerGetAllThreadsByClientIdApiArg = {
  /** The name of the box to retrieve emails from */
  boxName: 'INBOX' | 'SENT' | '[Gmail]/All Mail' | '[Gmail]/Spam';
  /** Optional: Filter to only fetch emails from a specific account */
  accountId?: string;
  /** Maximum number of emails to fetch per account (default: 50, max: 100) */
  limit?: number;
  /** Whether to include warmup emails in the results (default: true) */
  includeWarmup?: string;
};
export type MasterInboxControllerGetEmailThreadApiResponse = /** status 200  */ EmailThreadDto;
export type MasterInboxControllerGetEmailThreadApiArg = {
  accountId: string;
  initialMessageId: string;
};
export type MasterInboxControllerReplyWithAttachmentApiResponse = unknown;
export type MasterInboxControllerReplyWithAttachmentApiArg = {
  replyDto: ReplyDto;
};
export type CustomDomainsControllerSuggestDomainsApiResponse =
  /** status 200 Domain suggestions generated successfully */
    | DomainSuggestionsDto
    | /** status 201  */ DomainSuggestionsDto;
export type CustomDomainsControllerSuggestDomainsApiArg = {
  suggestDomainsDto: SuggestDomainsDto;
};
export type CustomDomainsControllerCheckAvailabilityApiResponse =
  /** status 200 Domain availability checked successfully */ void | /** status 201  */ object;
export type CustomDomainsControllerCheckAvailabilityApiArg = void;
export type CustomDomainsControllerCheckAvailabilityBatchApiResponse =
  /** status 200 Domain availability batch check completed */ void | /** status 201  */ object[];
export type CustomDomainsControllerCheckAvailabilityBatchApiArg = void;
export type CustomDomainsControllerPurchaseDomainsApiResponse =
  /** status 201 Domain purchase initiated successfully */ DomainPurchaseResponseDto;
export type CustomDomainsControllerPurchaseDomainsApiArg = {
  purchaseDomainsDto: PurchaseDomainsDto;
};
export type CustomDomainsControllerGetMyDomainsApiResponse =
  /** status 200 Domains retrieved successfully */ DomainListDto;
export type CustomDomainsControllerGetMyDomainsApiArg = void;
export type CustomDomainsControllerGetDomainDetailsApiResponse =
  /** status 200 Domain details retrieved successfully */ DomainDetailsDto;
export type CustomDomainsControllerGetDomainDetailsApiArg = {
  id: string;
};
export type CustomDomainsControllerVerifyDnsApiResponse = /** status 200 DNS verification triggered successfully */
  | void
  | /** status 201  */ object;
export type CustomDomainsControllerVerifyDnsApiArg = {
  id: string;
};
export type EmailAccountDto = {
  id: string;
  email: string;
  fromName: string;
  username: string;
  providerType: object;
  status: object;
  maxEmailPerDay: number;
  customTrackingUrl: string;
  createdAt: string;
  updatedAt: string;
  clientId: string;
  domain: string;
  maxEmailPerHour: number;
  minDelaySeconds: number;
  lastUsed: string;
  pausedAt: string;
  pauseReason: object;
  pauseMetadata: object;
  clientDomainId: string;
};
export type EmailAccountListDto = {
  accounts: EmailAccountDto[];
  total: number;
  offset: number;
  limit: number;
};
export type UpdateEmailAccountDto = {
  fromName?: string;
  maxEmailPerDay?: number;
  customTrackingUrl?: string;
};
export type EmailAccountWarmupPoolDto = {
  emailAccountId: string;
};
export type WarmupProfileDto = {
  id: string;
  emailAccountId: string;
  warmupIdentifierTag: string;
  createdAt: string;
  updatedAt: string;
  enabled: boolean;
  completed: boolean;
  warmupDurationDays: number;
  totalWarmupPerDay: number;
  dailyRampUp: number;
  replyRatePercentage: number;
  warmupMaxCount: number;
  warmupMinCount: number;
  maxThreadDepth: number;
  continueReplyRate: number;
  warmupReputation: string;
  totalEmailsSent: number;
  totalEmailsOpened: number;
  totalEmailsReplied: number;
};
export type WarmupClassDto = {
  warmupProfiles: WarmupProfileDto[];
};
export type AddWarmupDto = {
  /** Enable or disable warmup for this email account */
  enabled: boolean;
  /** Maximum number of warmup emails to send per day */
  totalWarmupPerDay: number;
  /** Number of additional emails to send each day during ramp-up */
  dailyRampUp: number;
  /** Percentage of warmup emails that should receive a reply */
  replyRatePercentage: number;
  /** Optional custom warmup key identifier */
  warmupIdentifierTag?: string;
  /** Number of days to warm up the email account */
  warmupDurationDays?: number;
  emailAccountId: string;
};
export type ExecuteWarmupDto = {
  /** Email account ID to execute warmup for */
  emailAccountId?: string;
  /** Bypass validation checks and execute warmup immediately */
  bypassValidation: boolean;
};
export type OutlookAuthInitDto = {
  url: string;
};
export type EmailImapSmtpProvider = {
  providerType: 'IMAP_SMTP' | 'OAUTH';
  password: string;
  smtpHost: string;
  smtpPort: number;
  smtpUseTls: boolean;
  imapHost: string;
  imapPort: number;
  imapUseTsl: boolean;
};
export type CreateImapSmtpEmailAccount = {
  email: string;
  fromName: string;
  username: string;
  customTrackingUrl?: string;
  maxEmailPerDay?: number;
  /** IMAP/SMTP provider configuration */
  provider: EmailImapSmtpProvider;
};
export type AddPoolEmailDto = {
  email: string;
  provider: object;
  smtpHost?: string;
  smtpPort?: number;
  smtpUsername?: string;
  smtpPassword?: string;
  imapHost?: string;
  imapPort?: number;
  imapUsername?: string;
  imapPassword?: string;
  oauthAccessToken?: string;
  oauthRefreshToken?: string;
  dailySendLimit?: number;
  dailyReceiveLimit?: number;
  notes?: string;
};
export type UpdatePoolEmailDto = {
  provider?: object;
  smtpHost?: string;
  smtpPort?: number;
  smtpUsername?: string;
  smtpPassword?: string;
  imapHost?: string;
  imapPort?: number;
  imapUsername?: string;
  imapPassword?: string;
  oauthAccessToken?: string;
  oauthRefreshToken?: string;
  dailySendLimit?: number;
  dailyReceiveLimit?: number;
  notes?: string;
};
export type BulkImportPoolEmailDto = {
  emails: AddPoolEmailDto[];
};
export type UpdatePoolConfigurationDto = {
  isEnabled?: boolean;
  minPoolSize?: number;
  targetPoolSize?: number;
  maxDailyInteractionsPerUser?: number;
  minReputationScore?: number;
  minHealthScore?: number;
  autoPauseOnBounce?: boolean;
  bounceThreshold?: number;
  autoPauseOnSpam?: boolean;
  spamThreshold?: number;
  warmupStartHour?: number;
  warmupEndHour?: number;
  warmupTimezone?: string;
};
export type SetSmtpCredentialsDto = {
  /** SMTP server hostname */
  smtpHost: string;
  /** SMTP server port */
  smtpPort: number;
  /** SMTP username (usually the email address) */
  smtpUsername: string;
  /** SMTP password */
  smtpPassword: string;
  /** IMAP server hostname */
  imapHost: string;
  /** IMAP server port */
  imapPort: number;
  /** IMAP username (defaults to smtpUsername if not provided) */
  imapUsername?: string;
  /** IMAP password (defaults to smtpPassword if not provided) */
  imapPassword?: string;
};
export type CreateCampaignDto = {
  name: string;
};
export type ShortCampaignStatsDto = {
  emailsSent: number;
  emailsOpened: number;
  emailsClicked: number;
  emailsReplied: number;
};
export type ShortCampaignDto = {
  status: 'DRAFT' | 'ACTIVE' | 'COMPLETED' | 'STOPPED' | 'PAUSED' | 'FAILED';
  stats?: ShortCampaignStatsDto;
  id: string;
  name: string;
  createdAt: string;
  sequenceTotalCount: number;
};
export type CampaignListDto = {
  campaigns: ShortCampaignDto[];
};
export type ScheduleDto = {
  startTime: string;
  endTime: string;
  timezone: string;
  daysOfWeek: number[];
  minTimeBetweenEmailsInMinutes: number;
  maxNewLeadsPerDay: number;
};
export type SequenceVariantDto = {
  id: string;
  subject: string;
  body: string;
  label: string;
};
export type SequenceDto = {
  delayDays: number;
  order: number;
  variants?: SequenceVariantDto[];
  subject: string;
  body: string;
};
export type LeadStatisticsDto = {
  id: string;
  leadId: string;
  campaignId: string;
  lastEmailSent: string;
  lastEmailOpened: string;
  lastEmailClicked: string;
  lastEmailReplied: string;
  totalEmailsSent: number;
  totalEmailsOpened: number;
  totalEmailsClicked: number;
  totalEmailsReplied: number;
};
export type LeadDto = {
  statistics?: LeadStatisticsDto[];
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
  company: string;
  isBlocked: boolean;
  isUnsubscribed: boolean;
  createdAt: string;
  updatedAt: string;
  categoryId: string;
};
export type CampaignStatisticsDto = {
  id: string;
  campaignId: string;
  date: string;
  emailsSent: number;
  emailsOpened: number;
  emailsClicked: number;
  emailsReplied: number;
  emailsBounced: number;
};
export type CampaignDto = {
  status: 'DRAFT' | 'ACTIVE' | 'COMPLETED' | 'STOPPED' | 'PAUSED' | 'FAILED';
  schedule?: ScheduleDto | null;
  sequences?: SequenceDto[] | null;
  leads: LeadDto[];
  statistics?: CampaignStatisticsDto[] | null;
  isTrackingEnabled?: boolean;
  id: string;
  name: string;
  clientId: string;
  createdAt: string;
  updatedAt: string;
};
export type UpdateCampaignDto = {
  name?: string;
  status?: object;
  isTrackingEnabled?: boolean;
};
export type AddLeadsToCampaignDto = {
  leadIds: string[];
};
export type UpdateCampaignDetailsDto = {
  name?: string;
  schedule?: ScheduleDto;
  sequences?: SequenceDto[];
};
export type PatchCampaignStatusDto = {
  status: 'DRAFT' | 'ACTIVE' | 'COMPLETED' | 'STOPPED' | 'PAUSED' | 'FAILED';
};
export type AddEmailAccountToCampaignDto = {
  emailAccountId: string;
};
export type RemoveEmailAccountDto = {
  id: string;
};
export type ExecuteCampaignDto = {
  bypassValidation: boolean;
};
export type CreateLeadDto = {
  email: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  company?: string;
};
export type LeadCsvImportResultDto = {
  total: number;
  imported: number;
  duplicated: number;
  duplicatedEmails: string[];
  duplicatedLeadIds: string[];
  createdLeadIds: string[];
  leads: LeadDto[];
};
export type CsvMappingDto = {
  email: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  company?: string;
};
export type CsvImportMappingDto = {
  mapping: CsvMappingDto;
};
export type UpdateLeadDto = {
  email?: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  company?: string;
};
export type AddToBlockListDto = {
  domain_block_list: string[];
  clientId?: string;
};
export type EmailSummaryDto = {
  /** The type of email */
  type: 'SENT' | 'REPLY' | 'RECEIVED';
  /** The time the email was sent */
  time: string;
  /** The body of the email */
  body: string;
  /** The subject of the email */
  subject: string;
  /** The sender of the email */
  from: object;
  /** The sender of the email */
  to: object;
};
export type EmailThreadSummaryDto = {
  /** The initial message ID of the email thread */
  initialMessageId: string;
  /** The last email in the thread */
  latestEmailInThread: EmailSummaryDto;
  /** Whether this thread contains warmup emails */
  isWarmup?: boolean;
};
export type AccountWithThreadsDto = {
  /** The account ID of the email thread */
  accountId: string;
  /** The email address of the account */
  accountEmail?: string;
  /** Email threads in this account */
  threads: EmailThreadSummaryDto[];
};
export type EmailBoxDto = {
  accountThreads: AccountWithThreadsDto[];
};
export type EmailInBoxDto = {
  /** The type of the email event */
  type: 'SENT' | 'REPLY' | 'RECEIVED';
  /** The message ID of the email */
  messageId: string;
  /** The time the email event occurred */
  time: string;
  /** The body content of the email */
  body: string;
  /** The subject of the email */
  subject: string;
  to: string;
  from: string;
  references: string;
};
export type EmailThreadDto = {
  /** The account ID of the email thread */
  accountId: string;
  emails: EmailInBoxDto[];
  /** The initial message ID of the email thread */
  initialMessageId: string;
};
export type ReplyDto = {
  /** Array of binary file attachments */
  attachments?: Blob[];
  accountId: string;
  inReplyTo: string;
  to: string;
  subject: string;
  body: string;
  references?: string[];
  cc?: string[];
};
export type DomainSuggestionItemDto = {
  /** Domain name */
  domain: string;
  /** Whether the domain is available for purchase */
  available: boolean;
  /** Price in cents (USD) */
  price: number | null;
  /** Currency */
  currency: string;
  /** Quality score (0-100) */
  qualityScore: number;
  /** Top-level domain */
  tld: string;
};
export type DomainSuggestionsDto = {
  /** List of domain suggestions */
  suggestions: DomainSuggestionItemDto[];
};
export type SuggestDomainsDto = {
  /** Business name to generate domain suggestions for */
  businessName: string;
  /** Number of domain suggestions to return */
  limit?: number;
};
export type DomainSetupResultDto = {
  /** Domain name */
  domain: string;
  /** Whether the domain setup was successful */
  success: boolean;
  /** Client domain ID */
  clientDomainId?: string;
  /** Cost in cents */
  cost?: number;
  /** Whether DNS was configured successfully */
  dnsConfigured?: boolean;
  /** Number of email accounts created */
  emailAccountsCreated?: number;
  /** List of email addresses created */
  emailAccounts?: string[];
  /** Error message if failed */
  error?: string;
  /** Step where process stopped */
  step: 'purchase' | 'dns' | 'email' | 'complete';
};
export type DomainPurchaseResponseDto = {
  /** Client ID */
  clientId: string;
  /** Total number of domains attempted */
  totalDomains: number;
  /** Number of successful setups */
  successful: number;
  /** Number of failed setups */
  failed: number;
  /** Total cost in cents */
  totalCost: number;
  /** Individual domain results */
  results: DomainSetupResultDto[];
};
export type PurchaseDomainsDto = {
  /** List of domain names to purchase */
  domains: string[];
  /** Number of email accounts to create per domain */
  emailsPerDomain?: number;
};
export type DomainEmailAccountDto = {
  /** Email address */
  email: string;
  /** Account status */
  status: 'ACTIVE' | 'FAILED' | 'DISABLED' | 'PAUSED';
  /** Whether warmup is completed */
  warmupCompleted: boolean;
  /** Warmup reputation score */
  warmupReputation: string | null;
};
export type ClientDomainSummaryDto = {
  /** Domain ID */
  id: string;
  /** Domain name */
  domain: string;
  /** Domain status */
  status: 'CONFIGURING' | 'ACTIVE' | 'DNS_PENDING' | 'FAILED' | 'EXPIRED' | 'SUSPENDED';
  /** Purchase date */
  purchasedAt: string;
  /** Expiration date */
  expiresAt: string;
  /** Whether DNS is configured */
  dnsConfigured: boolean;
  /** Whether DNS is verified */
  dnsVerified: boolean;
  /** Number of email accounts */
  emailAccountCount: number;
  /** Email accounts on this domain */
  emailAccounts: DomainEmailAccountDto[];
  /** Total DNS records */
  dnsRecordCount: number;
  /** Verified DNS records */
  dnsRecordsVerified: number;
};
export type DomainListDto = {
  /** List of client domains */
  domains: ClientDomainSummaryDto[];
};
export type WarmupProfileSummaryDto = {
  /** Whether warmup is completed */
  completed: boolean;
  /** Duration of warmup in days */
  warmupDurationDays: number;
  /** Total warmup emails per day */
  totalWarmupPerDay: number;
  /** Warmup reputation score */
  warmupReputation: string | null;
};
export type EmailAccountStatsDto = {
  /** Date of the stats */
  date: string;
  /** Number of emails sent */
  sent: number;
  /** Number of emails opened */
  opened: number;
  /** Number of replies received */
  replied: number;
};
export type DomainEmailAccountDetailsDto = {
  /** Email account ID */
  id: string;
  /** Email address */
  email: string;
  /** Account status */
  status: 'ACTIVE' | 'FAILED' | 'DISABLED' | 'PAUSED';
  /** Warmup profile */
  warmupProfile?: WarmupProfileSummaryDto | null;
  /** Recent statistics */
  recentStats: EmailAccountStatsDto[];
};
export type DomainDnsRecordDto = {
  /** DNS record ID */
  id: string;
  /** Record type */
  recordType: 'MX' | 'TXT' | 'A' | 'CNAME';
  /** Record name */
  name: string;
  /** Record value */
  value: string;
  /** Priority (for MX records) */
  priority: number | null;
  /** Purpose of the record */
  purpose: string | null;
  /** Whether the record is verified */
  verified: boolean;
  /** Verification timestamp */
  verifiedAt: string | null;
};
export type DomainDetailsDto = {
  /** Domain ID */
  id: string;
  /** Domain name */
  domain: string;
  /** Domain status */
  status: 'CONFIGURING' | 'ACTIVE' | 'DNS_PENDING' | 'FAILED' | 'EXPIRED' | 'SUSPENDED';
  /** Registrar */
  registrar: string;
  /** Purchase date */
  purchasedAt: string;
  /** Expiration date */
  expiresAt: string;
  /** Registration cost in cents */
  registrationCost: number;
  /** Auto-renew enabled */
  autoRenew: boolean;
  /** DNS configured */
  dnsConfigured: boolean;
  /** DNS verification timestamp */
  dnsVerifiedAt: string | null;
  /** Email accounts on this domain */
  emailAccounts: DomainEmailAccountDetailsDto[];
  /** DNS records for this domain */
  dnsRecords: DomainDnsRecordDto[];
};
export const {
  useEmailAccountControllerGetAllEmailAccountsQuery,
  useEmailAccountControllerGetEmailAccountQuery,
  useEmailAccountControllerUpdateEmailAccountMutation,
  useEmailAccountControllerDeleteEmailAccountMutation,
  useEmailAccountControllerTestConnectionMutation,
  useEmailAccountControllerGetWarmupStatusQuery,
  useEmailAccountControllerStartWarmupMutation,
  useEmailAccountControllerPauseWarmupMutation,
  useWarmupPoolControllerCreateWarmupPoolMutation,
  useWarmupPoolControllerAddToWarmupPoolMutation,
  useWarmupPoolControllerRemoveFromWarmupPoolMutation,
  useWarmupPoolControllerGetWarmupPoolQuery,
  useWarmupProfileControllerGetActiveWarmupProfilesQuery,
  useWarmupProfileControllerGetAllWarmupProfilesQuery,
  useWarmupProfileControllerUpsertWarmupProfileMutation,
  useWarmupProfileControllerGetWarmupStatsQuery,
  useWarmupProfileControllerExecuteInboxVerificationMutation,
  useWarmupProfileControllerExecuteWarmupMutation,
  useEmailAuthControllerGoogleAuthQuery,
  useEmailAuthControllerGoogleAuthCallbackQuery,
  useEmailAuthControllerOutlookAuthQuery,
  useEmailAuthControllerOutlookAuthCallbackQuery,
  useEmailAuthControllerImapSmtpCredentialsMutation,
  useAdminSharedPoolControllerGetAllPoolEmailsQuery,
  useAdminSharedPoolControllerAddPoolEmailMutation,
  useAdminSharedPoolControllerGetPoolEmailQuery,
  useAdminSharedPoolControllerUpdatePoolEmailMutation,
  useAdminSharedPoolControllerDeletePoolEmailMutation,
  useAdminSharedPoolControllerBulkImportPoolEmailsMutation,
  useAdminSharedPoolControllerActivatePoolEmailMutation,
  useAdminSharedPoolControllerPausePoolEmailMutation,
  useAdminSharedPoolControllerDisablePoolEmailMutation,
  useAdminSharedPoolControllerTestEmailConnectionMutation,
  useAdminSharedPoolControllerGetPoolConfigurationQuery,
  useAdminSharedPoolControllerUpdatePoolConfigurationMutation,
  useAdminSharedPoolControllerGetPoolStatsQuery,
  useAdminSharedPoolControllerGetPoolHealthQuery,
  useAdminSharedPoolControllerGetEmailDailyStatsQuery,
  useAdminSharedPoolControllerGetPoolDailyStatsQuery,
  useAdminSharedPoolControllerGetOAuthStatusQuery,
  useAdminSharedPoolControllerInitiateGoogleOAuthQuery,
  useAdminSharedPoolControllerGoogleOAuthCallbackQuery,
  useAdminSharedPoolControllerConnectOutlookClientCredentialsMutation,
  useAdminSharedPoolControllerInitiateOutlookOAuthQuery,
  useAdminSharedPoolControllerOutlookOAuthCallbackQuery,
  useAdminSharedPoolControllerSetSmtpCredentialsMutation,
  useAdminSharedPoolControllerRefreshTokenMutation,
  useUserWarmupStatusControllerGetMyWarmupStatusQuery,
  useUserWarmupStatusControllerGetMyWarmupInteractionsQuery,
  useUserWarmupStatusControllerGetPoolStatsQuery,
  useCampaignControllerCreateCampaignMutation,
  useCampaignControllerGetAllCampaignsQuery,
  useCampaignControllerGetCampaignQuery,
  useCampaignControllerUpdateCampaignMutation,
  useCampaignControllerDeleteCampaignMutation,
  useCampaignControllerAddLeadsToCampaignMutation,
  useCampaignControllerUnsubscribeQuery,
  useCampaignControllerUpdateCampaignDetailsMutation,
  useCampaignControllerPatchCampaignStatusMutation,
  useCampaignControllerGetEmailAccountsForCampaignQuery,
  useCampaignControllerAddEmailAccountToCampaignMutation,
  useCampaignControllerRemoveEmailAccountFromCampaignMutation,
  useCampaignSequenceControllerGetSequencesQuery,
  useCampaignSequenceControllerAddSequenceMutation,
  useCampaignSequenceControllerFetchCampaignSequenceQuery,
  useCampaignSequenceControllerUpdateSequenceMutation,
  useCampaignSequenceControllerDeleteSequenceMutation,
  useCampaignAnalyticControllerGetAnalyticsOverviewQuery,
  useCampaignAnalyticControllerGetAnalyticsTimeSeriesQuery,
  useCampaignAnalyticControllerGetCampaignAnalyticsQuery,
  useCampaignAnalyticControllerExportCampaignDataQuery,
  useCampaignExecutionControllerExecuteCampaignMutation,
  useCampaignExecutionControllerUpdateStatisticsMutation,
  useCampaignExecutionControllerTrackClickAndRedirectQuery,
  useCampaignExecutionControllerTrackOpenedQuery,
  useCampaignTrackingControllerTrackOpenedQuery,
  useWebhookControllerCreateOrUpdateWebhookMutation,
  useWebhookControllerGetWebhooksByCampaignQuery,
  useWebhookControllerDeleteWebhookMutation,
  useWebhookControllerGetWebhookLogsQuery,
  useLeadControllerGetAllLeadsQuery,
  useLeadControllerCreateLeadMutation,
  useLeadControllerImportCsvMutation,
  useLeadControllerGetLeadQuery,
  useLeadControllerUpdateLeadMutation,
  useLeadControllerDeleteLeadMutation,
  useLeadControllerGetLeadsByEmailQuery,
  useLeadControllerGetLeadCategoriesQuery,
  useLeadControllerUpdateLeadCategoryMutation,
  useLeadControllerGetLeadsFromGlobalBlockListQuery,
  useLeadControllerAddToGlobalBlockListMutation,
  useLeadControllerAddLeadToGlobalBlockListMutation,
  useStatisticsControllerGetCampaignStatisticsQuery,
  useStatisticsControllerGetCampaignLeadStatisticsQuery,
  useStatisticsControllerGetCampaignMailboxStatisticsQuery,
  useStatisticsControllerGetEmailAccountWarmupStatsQuery,
  useStatisticsControllerGetMasterInboxStatisticsQuery,
  useMasterInboxControllerGetAllThreadsByClientIdQuery,
  useMasterInboxControllerGetEmailThreadQuery,
  useMasterInboxControllerReplyWithAttachmentMutation,
  useCustomDomainsControllerSuggestDomainsMutation,
  useCustomDomainsControllerCheckAvailabilityMutation,
  useCustomDomainsControllerCheckAvailabilityBatchMutation,
  useCustomDomainsControllerPurchaseDomainsMutation,
  useCustomDomainsControllerGetMyDomainsQuery,
  useCustomDomainsControllerGetDomainDetailsQuery,
  useCustomDomainsControllerVerifyDnsMutation,
} = injectedRtkApi;
